'use client';

import { c as _c } from "react/compiler-runtime";
import { WebAPILink } from '@/globals/webApiTypes/elements/WebAPILink';
import { ChevronLink, IconLinkContent } from '@/uiComposites/interactive/IconLink';
import { H2TextBlock, H3TextBlock } from '@/uiComposites/typography/headings';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { columns } from '@/uiPrimitives/layout/columns';
import { icon } from '@/uiPrimitives/media/icon';
import { textStyle } from '@/uiPrimitives/typography/text';
import { useState } from 'react';
import { MunicipalitySourceDataItem } from '@/sections/autocomplete/Autocomplete.types';
import { box } from '@/uiPrimitives/layout/box';
import { stack } from '@/uiPrimitives/layout/stack';
import { translateInline } from '@/globals/translate/translateInline';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
export const MunicaplitiesSection = t0 => {
  const $ = _c(11);
  const {
    backLink,
    provinces
  } = t0;
  const [selectedProvince, setSelectedProvince] = useState("");
  if (selectedProvince !== "") {
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(box({
      paddingBlockEnd: "10 | betweenH2Sections",
      paddingBlockStart: "8 | betweenCards"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== provinces || $[2] !== selectedProvince) {
    t2 = selectedProvince === "" && <span className={stack({
      rowGap: "8 | betweenCards"
    })}><H2TextBlock>{translateInline({
          en: "Choose your province",
          nl: "Kies uw provincie"
        })}</H2TextBlock><ul className={classes(columns({
        columnCount: "3",
        rowGap: "4 | betweenListItems"
      }))}>{provinces.map((t3, i) => {
          const {
            name
          } = t3;
          return <li key={i}><button className={classes(textStyle({
              fontWeight: "bold"
            }))} onClick={() => {
              setSelectedProvince(name);
            }} {...addTestSelector(`uiProvinceListItem-${name}`)}><IconLinkContent icon={<i aria-hidden={true} className={icon({
                icon: chevronIcon
              })} />}>{name}</IconLinkContent></button></li>;
        })}</ul></span>;
    $[1] = provinces;
    $[2] = selectedProvince;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== backLink || $[5] !== provinces || $[6] !== selectedProvince) {
    t3 = selectedProvince !== "" && <div className={stack({
      rowGap: "6 | betweenH4Sections"
    })}><button className={classes(textStyle({}))} onClick={() => {
        setSelectedProvince("");
      }}><IconLinkContent icon={<i aria-hidden={true} className={icon({
          icon: chevronIcon,
          adjustIcon: "flipHorizontal"
        })} />}>{backLink.text}</IconLinkContent></button><H3TextBlock>{translateInline({
          en: "All municipalities of",
          nl: "Alle gemeenten van"
        })}{" "}{selectedProvince}</H3TextBlock>{provinces.filter(province => province.name === selectedProvince).map(_temp2)}</div>;
    $[4] = backLink;
    $[5] = provinces;
    $[6] = selectedProvince;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(t0, municipalityIndex) {
  const {
    href,
    name: name_0
  } = t0;
  return <li key={municipalityIndex}><ChevronLink href={href} data-link-type="municipalitiyLink" className={textStyle({
      fontWeight: "bold"
    })} styling={{
      color: "positiveBlue:noVisited"
    }} {...addTestSelector(`uiMunicipalitiyLink-${name_0}`)}>{name_0}</ChevronLink></li>;
}
function _temp2(t0, provinceIndex) {
  const {
    municipalities
  } = t0;
  return <ul key={provinceIndex} className={classes(columns({
    columnCount: "3",
    rowGap: "6 | betweenH4Sections"
  }))}>{municipalities.map(_temp)}</ul>;
}